// extracted by mini-css-extract-plugin
export default {"wrapper":"ingredient-page_wrapper__CapOC","title":"ingredient-page_title__Zdo2Z"};